export class ivrList {
    constructor(ivrObj) {
        this.ivrID               = ivrObj.Id;
        this.ivrName		     = ivrObj.Description;
    }
}